<template>
  <div class="row">
    <div class="col-auto" style="min-width:300px">
      <div class="card">
        <div class="card-body p-0">
              <cardHead 
              :title="'Reports'"></cardHead>
              <load-area v-if="reportProcess"></load-area>
              <ul class="list-group border-none report" v-if="report.length>0">
                <li class="list-group-item border-top d-flex justify-content-between align-items-center pointer" :class="{'active':item.OperatorId==model.OperatorId}" @click="model.OperatorId=item.OperatorId" v-for="item in report" :key="item.OperatorId">
                  {{item.OperatorName}}
                  <span class="badge badge-primary badge-pill m-l-20">{{item.Count}}</span>
                </li>
              </ul>
              <p class="p-20 tcenter" v-if="report.length==0 && !reportProcess">Hiç veri yok.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
              <cardHead :title="'Scan Errors'"
              :buttons='[{
                title:"Truncate",
                icon:"fas fa-stop-circle",
                emit:"Truncate"
              }]'
              @truncate="truncate"></cardHead>
              <Form method="dialog" v-slot="{ errors }" class="floating-labels row  p-20 p-b-10" ref="form">
                <div class="col">
                  <formGroup :title="'Operator'" :as="'select'" :disabled="report.length==0" v-model="model.OperatorId" :errors="errors" @keydown.enter="get">
                        <template #input>
                            <option :value="null"></option>
                            <option v-for="item in report" :value="item.OperatorId" :key="item.OperatorId">{{item.OperatorName}} ({{item.Count}})</option>
                        </template>
                    </formGroup>
                </div>
                <div class="col">
                  <formGroup :title="'StartDate'" :type="'date'" :max="model.EndDate" v-model="model.StartDate" :errors="errors" @keydown.enter="get"></formGroup>
                </div>
                <div class="col">
                  <formGroup :title="'EndDate'" :type="'date'" :min="model.StartDate" v-model="model.EndDate" :errors="errors" @keydown.enter="get"></formGroup>
                </div>
                <div class="col">
                  <formGroup :title="'ErrorCount'" :type="'number'" v-model="model.ErrorCount" :errors="errors" @keydown.enter="get"></formGroup>
                </div>
                <div class="col-auto">
                  <Btn class="btn-success" @click="get()" :disabled="data==null" :process="data==null">Refresh</Btn>
                </div>
              </Form>
              <dataTable :name="'scanErrors'" v-if="data!=null" ref="agGrid" :columnDefs="columnDefs" :data="data" @cellClicked="showShow=$event?.data?.LogFile;"></dataTable>
              <load-area v-if="data==null" class="border-top"></load-area>
      </div>
    </div>
    <!-- <show v-if="showShow!=null" :id="showShow" @close="showShow=null" @reload="reload"></show> -->
    </div>
  </div>
</template>

<script>
  // import show from "./show";
  import moment from 'moment';
  export default {
    name: 'ScanErrors',
    // components:{show},
    data(){
      return { 
        columnDefs:[
          { headerName: "Id", width:80, field: "Id", filter: 'agNumberColumnFilter', sortable:true, cellClick:true, enableRowGroup: false},
          { headerName: "OperatorId", field: "OperatorId", filter: 'agNumberColumnFilter', width: 150, sortable:true, cellClick:true, enableRowGroup: false},
          { headerName: "OperatorName", field: "OperatorName", filter: 'agTextColumnFilter', flex: 1, minWidth:140, sortable:true, cellClick:true, enableRowGroup: false},
          { headerName: "Date",field: "Date", filter: 'agTextColumnFilter', width: 150, sortable:true, cellClick:true , enableRowGroup: false,
              valueFormatter:function(params){
                let diff=new Date().getTimezoneOffset();
                return moment(new Date(params.value).setMinutes(new Date(params.value).getMinutes()-diff)).format("DD.MM.YYYY HH:mm");
              }
          },
          { headerName: "Key",field: "Key", filter: 'agTextColumnFilter', flex: 1, minWidth:80, sortable:true, cellClick:true , enableRowGroup: false}
        ],
        data:null,
        showShow:null,
        model:{
          OperatorId:null,
          StartDate:null,
          EndDate:null,
          ErrorCount:null
        },
        reportProcess:true,
        report:[]
      }
    },
    created(){
      this.getReport();
      this.get();
    },
    watch:{
      showShow(){
        window.open(
          "https://reservations.ams3.digitaloceanspaces.com/logs/"+this.showShow,
          '_blank' // <- This is what makes it open in a new window.
        );
      }
    },
    methods:{
      getReport(){
        this.reportProcess=true;
        this.report=[];
        this.$appAxiosAdmin.get(`Tourscope/ScanErrors/Report`).then(response => {
          this.report=response.data;
          this.reportProcess=false;
        });
      },
      get(){
        this.data=null;
        this.$appAxiosAdmin.post(`Tourscope/ScanErrors/Filter`,this.model).then(response => {
          this.data=response.data;
        });
      },
      reload(){
        this.getReport();
        this.get();
      },
      remove(item){
          this.$swal({
              icon:"question",
              title:"Warning",
              text:"Are you sure you want to delete the operator named "+item.Name+"?",
              showCancelButton:true,
              confirmButtonText:"Yes",
              cancelButtonText:"No"
          }).then(question=>{
              if(question.isConfirmed){
                  this.$appAxiosAdmin.delete(`Operators/`+item.Id).then(() => {
                      this.$refs.agGrid.removeRow([item]);
                      this.$swal({
                          icon:"success",
                          title:"Success",
                          text:"The operator was successfully deleted.",
                          timer: 2000,
                          confirmButtonText:"Okey"
                      });
                  }).catch(err=>{
                    this.$isError(err);
                  });
              }
          });
      },
      truncate(){
          this.$swal({
              icon:"question",
              title:"Warning",
              text:"Are you sure you want to truncate scans?",
              showCancelButton:true,
              confirmButtonText:"Yes",
              cancelButtonText:"No"
          }).then(question=>{
              if(question.isConfirmed){
                  this.$appAxiosAdmin.get(`Tourscope/ScanErrors/Truncate`).then(() => {
                    this.reload();
                    this.$swal({
                      icon:"success",
                      title:"Success",
                      text:"The successfully truncated.",
                      timer: 2000,
                      confirmButtonText:"Okey"
                    });
                  }).catch(err=>{
                    this.$isError(err);
                  });
              }
          });
      }
    }
  }
</script>
<style scoped>
  .report li{
    border-left:none !important;
    border-right:none !important;
  }
  .report li:first-child{
    border-top:none !important;
  }
</style>
